import { ReactNode } from 'react'

import { customSections } from '../section-for-multiple-fields/constants'
import { FIELD_KEY } from '../../../../utils/constants'

import './section-wrapper.scss'

const fieldKeyTitleMap: Record<string, string> = {
    [FIELD_KEY.SOFFIT_TYPE]: 'Soffit',
    [FIELD_KEY.RAFTER_TAIL]: 'Rafter Tails',
    [FIELD_KEY.SUB_FASCIA]: 'Sub Fascia',
    [FIELD_KEY.GABLE_WIDTH]: 'Gable Width',
    [FIELD_KEY.GABLE_LADDER_FRAMING]: 'Gable Framing',
    [FIELD_KEY.EAVE_BLOCKING]: 'Eave Blocking',
    [FIELD_KEY.EAVE_WIDTH]: 'Eave Width',

    // automatically add titles for combined sections
    ...Object.fromEntries(customSections.map(({ sectionKey, sectionName }) => [sectionKey, sectionName])),
}

interface SectionWrapperProps {
    children: ReactNode
    fieldKey?: string
    ignoreWrapper?: boolean
}

export const SectionWrapper = ({ children, fieldKey, ignoreWrapper = false }: SectionWrapperProps) => {
    return (
        <section className={`main-panel-section ${!ignoreWrapper ? 'active' : ''}`}>
            {!ignoreWrapper && fieldKey && fieldKeyTitleMap[fieldKey] && (
                <label className="main-panel-section-label">{fieldKeyTitleMap[fieldKey]}</label>
            )}
            {children}
        </section>
    )
}
